export default {
      path: '/lvy-exposure-v2',
      component: () => import('./LVYExposureV2'),
      meta: {
        title: '10倍曝光的好处',
        designWidth:750,
        expireIn: '',
        axiosConfig: {
          baseURL: '',
          withCredentials: false,
          postContentType: 'JSON'
        }
      }
    }
